import Chart from "react-apexcharts";
import { useState } from "react";
import type { ApexOptions } from "apexcharts";

export default function RadialBarCart() {
  const [state] = useState<{
    series: ApexOptions["series"];
    options: ApexOptions;
  }>({
    series: [44, 55, 67],
    options: {
      chart: {
        height: 280,
        type: "radialBar" as const,
        width: 280,
        fontFamily: "YekanBakh-semiBold",
      },
      colors: ["#1728B6", "#255CFF", "#8EB7FF"],
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: "22px",
              fontFamily: "YekanBakh-Regular",
            },
            value: {
              fontSize: "16px",
              fontFamily: "YekanBakh-Regular",
            },
            total: {
              show: true,
              label: "مجموع",
              formatter: function () {
                return "249";
              },
            },
          },
        },
      },
      labels: ["محصولات", "دوره ها", "کاربران"],
      stroke: {
        lineCap: "round",
      },
      legend: {
        fontFamily: "YekanBakh-SemiBold",
        show: true,
        position: "bottom",
        horizontalAlign: "center",
      },
    },
  });

  return (
    <div className="w-full container-chart h-[90%]">
      <Chart
        options={state.options}
        series={state.series}
        type="radialBar"
        height={"100%"}
        width={"100%"}
      />
    </div>
  );
}
